import baseRoute from '../accounting/baseRoute';

export default `${baseRoute}/employeeUtilization` as const;
